/**
 * Entregar um arquivo ao leitor - a unica parte de uma exportacao que depende do DOM.
 *
 * Exportar tem duas metades, e elas moram em lugares diferentes. O CONTEUDO (as
 * linhas do CSV, as paginas do PDF) e da apresentacao: e regra de produto, e e testado
 * sem navegador. SALVAR e coisa da plataforma - `URL.createObjectURL` e um link
 * clicado, no navegador -, e e o renderizador que sabe fazer isso. Ele instala a
 * funcao no arranque, como instala a URL da API.
 *
 * Antes desta separacao (08/10/2026), os PDFs eram montados E baixados pela
 * apresentacao, que tocava `document`, e os CSVs eram montados e baixados pela view.
 * Nenhum dos dois era testavel inteiro.
 */
export class FileSaver {
    static { this.INSTANCE = new FileSaver(); }
    /** Chamado pelo renderizador antes de `kickStart`; num teste, um dublê. */
    install(target) {
        this.target = target;
    }
    save(file) {
        if (!this.target) {
            throw new Error('Nenhum destino de arquivo instalado - o renderizador deve chamar FileSaver.install');
        }
        this.target(file);
    }
}
//# sourceMappingURL=file-saver.js.map